import { Resume } from '@sr/types';
import { useThemeUI } from 'theme-ui';
import { ResumeTheme } from '../common/base-theme';
import { getCalcSize } from '../common/calc-size';
import Divider from '../common/Divider';
import {
  Box,
  Heading,
  Image,
  ResumeHeading,
  Text,
  WebsiteLink,
} from '../common/ui';

const Header = ({ resume }: { resume: Resume }) => {
  const theme = useThemeUI().theme as ResumeTheme;
  const calcSize = getCalcSize(theme.baseSize);
  const {
    city,
    email,
    firstName,
    lastName,
    phone,
    state,
    summary,
    title,
    website,
    website2,
  } = resume.about;
  const location = (city || state) && (
    <Divider divider=", ">
      {city}
      {state}
    </Divider>
  );
  const name = `${firstName} ${lastName}`;
  return (
    <>
      <Box as="header" variant="headerContainer" className="pdf-resume-header">
        <Box
          sx={{
            mb: calcSize(1.875),
            display: 'flex',
            flexWrap: ['wrap', 'nowrap'],
          }}
        >
          <Box
            sx={{
              width: ['100%', 220],
              flexGrow: 0,
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              mb: [24, 0],
            }}
          >
            {resume.profilePhotoUrl && (
              <Image
                src={resume.profilePhotoUrl}
                width={48}
                height={48}
                sx={{
                  borderRadius: 999,
                  height: 48,
                  width: 48,
                  objectFit: 'cover',
                }}
              />
            )}
          </Box>
          <Box
            sx={{
              '@media screen and (min-width: 35em)': {
                display: 'grid',
                gridAutoFlow: 'column',
                gridAutoColumns: 'max-content',
                gridTemplateRows: '1fr 1fr',
                columnGap: 48,
                flexGrow: 1,
                justifyContent: 'flex-end',
              },
              pr: [0, 48],
            }}
          >
            {location && <Text>{location}</Text>}
            {email && <Text>{email}</Text>}
            {website && (
              <Text>
                <WebsiteLink url={website} />
              </Text>
            )}
            {website2 && (
              <Text>
                <WebsiteLink url={website2} />
              </Text>
            )}
            {phone && <Text>{phone}</Text>}
          </Box>
        </Box>
        <ResumeHeading>
          <Divider divider=", ">
            {name}
            {title}
          </Divider>
        </ResumeHeading>
        <Heading variant="resumeSummary">{summary}</Heading>
      </Box>
    </>
  );
};

export default Header;
